import BlockRegistry from '../../BlockRegistry';

export function registerServoMotor() {
    BlockRegistry.register('servoMotor_servo_setAngle', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        const angle = context.getInputValue(block, 'ANGLE');
        if (context.board && context.board.architecture === 'esp32') {
            context.addInclude('#include <ESP32Servo.h>');
        } else {
            context.addInclude('#include <Servo.h>');
        }
        
        const servoName = `servo_${pin}`;
        
        // addGlobal requires a unique key and the code to inject
        context.addGlobal(servoName, `Servo ${servoName};`);
        context.addSetup(`${servoName}.attach(${pin});`);
        
        return `${servoName}.write(${angle})`;
    });
}
